
import {Vue, Component} from 'vue-property-decorator';
import Pagination from "@/components/Pagination/index.vue";
import Template from "@/views/system-management/template/index.vue";
import {downloadPiPackaging, getChecksumChangedCount, queryPiPackaging} from "@/api/customer-package";

@Component({
  name: "piPackageManagement",
  components: {Template, Pagination}
})
export default class extends Vue {

  private searchParams = {
    piCodeKeyword: '',
    onlyShowChanged: false,
  };

  private tableLoading = false;
  private tableData = [];
  private changeQuantity = 0;

  private page = {
    pageNumber: 1,
    pageSize: 20,
    total: 0,
  };

  created() {
    this.getChangeQuantity();
    this.getList();
  }

  private async getChangeQuantity() {
    const res = await getChecksumChangedCount() as any;
    this.changeQuantity = typeof res === "number" ? res : Number(res?.data) || 0;
  }

  private async getList() {
    this.tableLoading = true;
    const params = {
      ...this.searchParams,
      pageNumber: this.page.pageNumber,
      pageSize: this.page.pageSize,
    }
    const res = await queryPiPackaging(params) as any;
    this.page.total = Number(res.total);
    this.tableData = res.list.map(item => {
      item.currentCheckSum = item.currentCheckSum? item.currentCheckSum : "无校验和值";
      item.downloadChecksum = item.downloadChecksum? item.downloadChecksum : "无校验和值";
      item.modifiedAfterDownload = item.downloadDate && item.currentCheckSum !== item.downloadChecksum;
      return item;
    });
    this.tableLoading = false;
  }

  private onlyShowChanged() {
    this.searchParams.onlyShowChanged = !this.searchParams.onlyShowChanged;
    this.searchParams.piCodeKeyword = "";
    this.page.pageNumber = 1;
    this.getList();
  }

  private gotoDetail(row) {
    const data = { piId: row.id };
    const item = encodeURIComponent(JSON.stringify(data));
    this.$router.push(`/piPackageDetail?item=${item}`);
  }

  private gotoNoPackageDetail(row) {
    const data = { piId: row.id };
    const item = encodeURIComponent(JSON.stringify(data));
    this.$router.push(`/noPackageDetail?item=${item}`);
  }

  private async download(row) {
    await downloadPiPackaging(row.id)
        .then(() => {
          row.downloadDate = this.getLocalDate(new Date());
          row.downloadChecksum = row.currentCheckSum;
          row.modifiedAfterDownload = false;
          this.getChangeQuantity();
        });
  }

  private getLocalDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}年${month}月${day}日`;
  }
}
